import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditPaymentMode = ({ show, onClose, selectedId, refresh }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [paymode, setPaymode] = useState([]);
    const [paymentmode_name, setname] = useState('');
    const [transaction_id, setTID] = useState('1');
    const [description, setdescription] = useState('');
    const [errors, setErrors] = useState({});

    useEffect(() => {
        axios.get(`${baseURL}/paymentmode/${selectedId}`)
          .then(response => {
            setPaymode(response.data);
            setname(response.data.paymentmode_name);
            setTID(String(response.data.transaction_id));
            setdescription(response.data.description);
          })
          .catch(error => {
            console.log('There was an error fetching the posts!', error);
          });
    }, []);

    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const validate = () => {
        const newErrors = {};
        if (!paymentmode_name.trim()) {
            newErrors.name = "This Field is Required.";
            return newErrors;
        }

        const regex = /^[A-Za-z\s]+$/;
        if (!regex.test(paymentmode_name)) {
            newErrors.name = "Not a Valid Name";
            return newErrors;
        }

        return newErrors;
    };
    
    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { paymentmode_name, transaction_id, description };

        // Create a new post
        axios.put(`${baseURL}/paymentmode/${selectedId}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Payment Mode Updated Successfully!");
            })
            .catch(error => {
                console.log(error);
                toast.error("Payment Mode Updation Failed");
            });
    };

    return (
        <Modal show={show}  size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Payment Mode</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Payment Mode<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Payment Mode"
                                    maxLength={100} 
                                    value={paymentmode_name} 
                                    onChange={(e) => setname(formatName(e.target.value))} 
                                />
                                {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Transaction ID (If Needed)<span className="required">*</span></label>
                                <div className='mt-2'>
                                    <div className="form-check-inline me-5">
                                        <input
                                            className="form-check-input me-1"
                                            type="radio"
                                            name="trans_id"
                                            value="0"
                                            checked={transaction_id === '0'}
                                            onChange={() => setTID('0')}
                                        />
                                        <label className="form-check-label text-black font-w400 fs-7">
                                            Yes
                                        </label>
                                    </div>
                                    <div className="form-check-inline">
                                        <input
                                            className="form-check-input me-1"
                                            type="radio"
                                            name="trans_id"
                                            value="1"
                                            checked={transaction_id === '1'}
                                            onChange={() => setTID('1')}
                                        />
                                        <label className="form-check-label text-black font-w400 fs-7">
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Description</label>
                                <textarea rows={2} className="form-control h-auto" name="comment" placeholder="Description" maxLength={255} value={description} onChange={(e) => setdescription(formatName(e.target.value))}/>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button type="submit" className="btn btn-sm btn-primary">Update Payment Mode<i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default EditPaymentMode;
